import { Collapse, Tooltip } from 'antd'
import React from 'react'
import { FormattedHTMLMessage, FormattedMessage, useIntl } from 'react-intl'

import categorizeTag from '../../data/categorizeTag'
import categorizeTagTitleKo from '../../data/categorizeTagTitleKo'
import ctgNameData from '../../data/ctgNameData'

import { StickerCategory } from '../../types'
const CategorizedTagHeader = ({
  emoji,
  title,
}: {
  emoji: string
  title: string
}) => {
  return (
    <div style={{ display: 'flex', fontSize: 12, height: 18 }}>
      <p style={{ margin: '0px 12px 0px 0px' }}>{emoji}</p>
      <p>{title}</p>
    </div>
  )
}
type TagSearchBoxProp = {
  everyStickerCategory: StickerCategory[]
  selectedCategory: number[]
  addEmojiCategory: (emojiIndex: StickerCategory) => void
}
// {selectTag, selectedTag}:{}
export default function TagSelectBox({
  everyStickerCategory,
  selectedCategory,
  addEmojiCategory,
}: TagSearchBoxProp) {
  const intl = useIntl()
  return (
    <div>
      <p
        style={{
          fontSize: 14,
          lineHeight: '20px',
          color: '#000',
          marginBottom: 4,
        }}
        className={
          intl.locale === 'en'
            ? 'title-view-of-modal-title title-view-of-modal-title-en'
            : 'title-view-of-modal-title'
        }
      >
        <FormattedMessage
          id="SelectTag.modal.categorySearch.title"
          defaultMessage="Category Search"
        />
      </p>
      <p className="tag-selection-description">
        <FormattedHTMLMessage
          id="SelectTag.modal.categorySearch.description"
          defaultMessage="What kind of emotion or situation would you use this sticker in?"
        />
      </p>

      <Collapse
        style={{ width: 210, border: '1px solid #979797', background: '#fff' }}
        accordion
      >
        {everyStickerCategory &&
          categorizeTag.map((tag, idx) => {
            const title =
              intl.locale === 'ko' ? categorizeTagTitleKo[idx] : tag[1]
            return (
              <Collapse.Panel
                id="emoji_panel"
                header={
                  <CategorizedTagHeader
                    emoji={tag[0] as string}
                    title={title as string}
                  />
                }
                key={idx}
                className="select-categorized-tag"
              >
                <div
                  style={{
                    maxHeight: 190,
                    overflow: 'auto',
                    width: 'inherits',
                  }}
                >
                  {(tag[2] as string[]).map((emoji, index) => {
                    const currentEmoji = everyStickerCategory.find(
                      (ctg) => ctg.icon === emoji,
                    )

                    const currentEmjNameData = currentEmoji
                      ? ctgNameData.find(
                          (data) => data.emoji === currentEmoji.icon,
                        )
                      : null
                    if (!currentEmjNameData || !currentEmoji) return null

                    return (
                      <Tooltip
                        placement="top"
                        title={
                          currentEmoji && currentEmjNameData
                            ? intl.locale === 'ko'
                              ? currentEmjNameData.name_ko
                              : currentEmoji.name
                            : null
                        }
                        key={index}
                      >
                        <span
                          className={
                            selectedCategory.includes(currentEmoji.index)
                              ? 'select-categorized-tag-emoji selected-modal-emoji'
                              : 'select-categorized-tag-emoji modal-emoji'
                          }
                          onClick={() => {
                            addEmojiCategory(currentEmoji)
                          }}
                        >
                          {emoji}
                        </span>
                      </Tooltip>
                    )
                  })}
                </div>
              </Collapse.Panel>
            )
          })}
      </Collapse>
    </div>
  )
}
